module.exports = __webpack_public_path__ + "static/media/tenancy-web1.45c1dae2.png";